import React, { Component } from "react";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import AddSharpIcon from '@material-ui/icons/AddSharp';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import { FormControl, Button, InputGroup, Table, Form, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import axios from '../../../axios';
import apiError from '../../../error';
import CreateRoleModal from './create-roles';
import './iam-roles.css';
import { debounce, getCookie } from "../../../function";
import Loader from "../../../component/loader/loader";

export default class Roles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roles: [],
            search: '',
            loading: false,
            limit: 10,
            activePage: 1,
            count: 0,
            editRoleId: null,
            showRoleModal: false,
        }
        this.loadRoles();
        this.isTAconnected = getCookie('isTAconnected');
        this.isTASyncing = getCookie('isTASyncing');
    }

    nextPath = path => this.props.history.push(path);

    handleEditRole = (roleId) => {
        this.setState({ editRoleId: roleId, showRoleModal: true });
    };

    handleCloseRoleModal = () => {
        this.setState({ editRoleId: null, showRoleModal: false });
        this.props.handleCreateRolesModal && this.props.handleCreateRolesModal();
    };

    componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search || prevProps.limit !== this.props.limit) {
            this.setState({ activePage: 1 }, () => this.loadRoles());
        }
    }

    getPageLimit = () =>
        this.props.limit != null && this.props.limit !== "" ? this.props.limit : this.state.limit;

    loadRoles = debounce(() => {
        this.setState({ loading: true });
        axios.get('/api/roles', {
            params: {
                search: this.props.search,
                limit: this.getPageLimit(),
                page: this.state.activePage
            }
        })
            .then(res => {
                this.setState({ loading: false, roles: res.data.roles, count: res.data.count });
            })
            .catch(err => this.setState({ loading: false }) && apiError(err));
    }, 500)

    deleteRoles = (roleId) => {
        swal({
            title: "Do you want to delete Role?",
            icon: "warning",
            buttons: ['No', 'Yes'],
        })
            .then(willSuccess => {
                if (willSuccess) {
                    this.setState({ loading: true });
                    axios.delete('/api/roles/' + roleId, {})
                        .then(res => {
                            this.loadRoles();
                            this.setState({ search: "" });
                            this.setState({ loading: false });
                            toast.success("Role Deleted Successfully");
                        })
                        .catch(err => this.setState({ loading: false }) && apiError(err));
                }
            });
    }

    render() {
        return (
            <>

                {/* <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Roles</h4>
                            </div>
                        </div>
                        {!this.isTAconnected &&
                            <div className="col-md-8 flexFilterButtons">
                                <div className="btn-container float-right d-flex align-items-center">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            this.isTASyncing ? (
                                                <Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
                                            ) : (
                                                <Tooltip id="top" className="d-none" />
                                            )
                                        }
                                    >
                                        <Button className={`btn-primary ${this.isTASyncing ? "disabledCls2" : ''}`} onClick={e => { if (!this.isTASyncing) return this.nextPath('/iam/roles/0') }}><AddSharpIcon className="btn-icon"></AddSharpIcon>Create Roles</Button>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        }
                    </div>
                </div> */}

                <div className="tableContainerWrapInner">
                    <Table>
                        <thead className="bg-light">
                            <tr>
                                <th>Role</th>
                                <th>Description</th>
                                <th>Users</th>
                                {!this.isTAconnected && <th>Action</th>}

                            </tr>
                        </thead>
                        <tbody>
                            {this.state.roles.length > 0 ? this.state.roles.map((role, index) => {
                                return <tr key={index}>
                                    <td style={{ cursor: 'pointer' }} onClick={e => this.nextPath('/iam/roles/' + role.id)}>{role.name}</td>
                                    <td>{role?.description || "-"}</td>
                                    <td>{role?.employeesCount || "-"}</td>
                                    {!this.isTAconnected &&
                                        <td>
                                            <Dropdown
                                                className="action-dropdown dropdownIcon" ref={this.selectRef}>
                                                <Dropdown.Toggle className="btn-only" id="dropdown-basic">
                                                    <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => (role.type === "Managed" || this.isTAconnected) ? this.nextPath('/iam/roles/' + role.id) : this.handleEditRole(role.id)}>{(role.type === "Managed" || this.isTAconnected) ? "View" : "Edit"}</Dropdown.Item>
                                                    {role.type !== "Managed" && !this.isTAconnected &&
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                this.isTASyncing ? (
                                                                    <Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <Tooltip id="top" className="d-none" />
                                                                )
                                                            }
                                                        >
                                                            <Dropdown.Item className={`${this.isTASyncing && 'disabledCls3'}`} onClick={e => { if (!this.isTASyncing) return this.deleteRoles(role.id) }}>Delete</Dropdown.Item>
                                                        </OverlayTrigger>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    }
                                </tr>
                            }) : <tr><td colSpan={4} className="text-center text-muted py-4">No role found</td></tr>}
                        </tbody>
                    </Table>

                    {this.state.roles.length > 0 &&
                        <div className="pagination-Wrap">
                            <div className="row">
                                <div className="col-md-6">
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.getPageLimit()}
                                        totalItemsCount={this.state.count}
                                        onChange={(pageNumber) => this.setState({ activePage: pageNumber }, () => this.loadRoles())}
                                    />
                                </div>
                                <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                    <div className="w-100 pgCount">
                                        <p>
                                            {this.state.count === 0
                                                ? 0
                                                : this.state.activePage * this.getPageLimit() + 1 - this.getPageLimit()}
                                            -
                                            {this.state.activePage * this.getPageLimit() > this.state.count
                                                ? this.state.count
                                                : this.state.activePage * this.getPageLimit()}{" "}
                                            of {this.state.count} records
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <CreateRoleModal
                    show={this.props.createRolesShow || this.state.showRoleModal}
                    handleModal={this.handleCloseRoleModal}
                    load={this.loadRoles}
                    roleId={this.state.editRoleId}
                />
            </>
        );
    }
}